import { render } from "./Pop.vue?vue&type=template&id=b622994c&scoped=true&lang=pug"
import script from "./Pop.vue?vue&type=script&lang=js"
export * from "./Pop.vue?vue&type=script&lang=js"

import "./Pop.vue?vue&type=style&index=0&id=b622994c&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b622994c"]])

export default __exports__